<template>
  <div :class="classes">
    <campaign-tag-curve
      v-if="!bottom"
      :is-cashback="isCashback"
      class="curve -left"
      reverse
    />

    <campaign-tag-curve
      :class="['curve -right', { '-bottom': bottom }]"
      :is-cashback="isCashback"
    />

    <campaign-tag-curve
      v-if="isExclusive"
      class="curve -right"
      :is-exclusive="isExclusive"
    />

    <figure
      v-if="! rescue && showDiscontTag && !isDynamic"
      :class="['-discount tag', { '-cashback': isCashback, '-bottom': bottom }]"
    >
      <figcaption
        v-text="value"
        v-if="value"
      />
      <figcaption
        v-else-if="isFromNow && !isExclusive"
        class="-from-now"
      >
        De {{ formatMoney(discountValue) }} por {{ formatMoney(fromNowDiscountValue) }}
      </figcaption>
      <figcaption
        v-else-if="isFromNow && isExclusive"
        class="-cashback-engagement"
      >
        {{ formatMoney((discountValue - fromNowDiscountValue)) }} OFF
      </figcaption>
      <figcaption
        v-else-if="isAward || isEngagement"
        class="-cashback-engagement"
        v-text="isAward ? 'Prêmio' : 'Recompensa'"
      />
      <figcaption
        v-else
        :class="[{ '-twoForOne': discount === '2x1' }]"
      >
        {{ isCashback ? `${discount} de volta` : discount }}
      </figcaption>
    </figure>

    <section
      v-if="isExclusive || isDynamic"
      :class="['exclusive', { 'only-exclusive': isExclusive && rescue}]"
    >
      <campaign-tag-curve
        v-if="isExclusive"
        class="curve -center"
        is-exclusive
        reverse
      />

      <figure class="-exclusive tag">
        <figcaption>EXCLUSIVO</figcaption>
      </figure>

      <campaign-tag-curve
        v-if="isExclusive && rescue"
        class="curve -right"
        is-exclusive
      />
    </section>
  </div>
</template>

<script>
import CampaignTagCurve from '@components/Campaign/CampaignTagCurve'

export default {
  components: { CampaignTagCurve },
  props: {
    discountType: {
      type: String,
      default: 'percentage'
    },
    discountValue: {
      type: Number,
      default: 0
    },
    value: String,
    fromNowDiscountValue: {
      type: Number,
      default: 0
    },
    discountSymbol: {
      type: String,
      default: '%'
    },
    showDiscontTag: {
      type: Boolean,
      default: true
    },
    isExclusive: Boolean,
    isCashback: Boolean,
    isAward: Boolean,
    isEngagement: Boolean,
    isFromNow: {
      type: Boolean,
      default: false
    },
    bottom: Boolean,
    rescue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDynamic () {
      return this.discountSymbol === 'dynamic'
    },
    discount () {
      if (this.discountSymbol === 'GRÁTIS' || this.discountSymbol === '2x1') { return this.discountSymbol }
      const toMoney = (value) => value.toFixed(2).replace('.', ',')
      const discount = this.discountType === 'percentage'
        ? this.formatCashback
        : `${this.discountSymbol} ${toMoney(this.discountValue)}`
      return discount
    },

    formatCashback () {
      if (this.isCashback) return `${this.discountValue.toString().replace('.', ',')}%`
      return `${this.discountValue.toString().replace('.', ',')}% OFF`
    },

    classes () {
      const classes = [
        'campaign-tag', {
          '-only-discount': !this.isExclusive && this.discount,
          '-cashback': this.isCashback,
          '-bottom': this.bottom,
          '-is-from-now': this.isFromNow && !this.isExclusive
        }]
      return classes
    }
  },
  methods: {
    formatMoney (value) {
      if (!value) return 'R$ 0,00'
      const toMoney = (value / 100).toFixed(2).replace('.', ',')
      return `R$ ${toMoney.substring(0, (toMoney.length - 3))}`
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

$campaign-tag-height: 25px;

$campaign-tag-size: auto $campaign-tag-height;

.campaign-tag {
  @include size($campaign-tag-size);
  position: relative;
  font-family: $base-font-family;
  font-weight: 700;
  display: flex;
  align-items: stretch;
  justify-content: center;

  &.-bottom {
    height: 16px;
    font-size: 9px;
    font-weight: 400;

    & > .campaign-tag-curve {
      height: 16px;
      right: -32px;
    }
  }

  & > .exclusive, & > .bottom {
    display: flex;
    align-items: stretch;
    justify-content: center;
    position: relative;
    right: 38px;

    &.only-exclusive {
      right: 205px;
      z-index: 1;
    }
  }

  & > .tag,
  & > .-bottom > .tag,
  & > .cashback > .tag,
  & > .exclusive > .tag {
    padding: 2px 5px;
    text-align: center;
    color: #fff;
    line-height: 22px;
    font-size: 13px;
    white-space: nowrap;

    &.-discount {
      background-color: $primary-color-placeholder;
      background-color: var(--color-primary);
    }

    & > .-twoForOne {
      padding: 0 10px;
    }

    & > .-cashback-engagement {
      width: 72px;
    }
    &.-from-now {
      width: 100%;
    }

    &.-exclusive {
      background-color: $base-color;
      font-size: 9px;
      z-index: 1;
    }

    &.-bottom {
      display: flex;
      align-items: center;
      justify-content: center;

      z-index: 1;
      padding: 0 5px;
      min-width: 70px;
      font-size: 8.5px;
      text-transform: uppercase;
    }

    &.-cashback {
      background-color: $tertiary-color-placeholder;
      background-color: var(--color-tertiary);
    }
  }

  & > .curve,
  & > .cashback > .tag,
  & > .bottom > .tag,
  & > .exclusive > .curve {
    height: $campaign-tag-height;

    &:not(.-center) {
      width: 48px;
      position: absolute;
      top: 0;

      &:not(.-bottom) { z-index: -1; }

      &.-bottom { transform: rotateX(180deg); }
    }

    &.-left { left: -37px; }

    &.-right { right: -37px; }

    &.-center {
      position: relative;
      left: 5px;
    }
  }

  &:not(.-only-discount) {
    left: 94px;

    & > .tag.-discount { padding-right: 20px; }
    & > .curve.-right { right: 1px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Campaign/CampaignTag.vue